import React from 'react';
import { NoMatchPage } from 'components/pages';

export interface NoMatchProps {}

const NoMatch: React.FC<NoMatchProps> = () => {
    return <NoMatchPage />;
};

export default NoMatch;
